import { render } from "./ReferralLoyaltyConfig.vue?vue&type=template&id=0ac9d65f&ts=true"
import script from "./ReferralLoyaltyConfig.vue?vue&type=script&lang=ts"
export * from "./ReferralLoyaltyConfig.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__